module.exports = __webpack_public_path__ + "img/worship_btn.81196034.png";